import React, { useState, useEffect } from 'react';
import { Box, Typography, Chip, Avatar, IconButton, useTheme, useMediaQuery } from '@mui/material';
import { CalendarToday, AccessTime, Person, VideoCall, Description, Medication } from '@mui/icons-material';
import colors from '../../../shared-colors';
import { formatDate, formatTime } from '../utils/dateUtils';
import { getVisitTypeLabel } from '../utils/visitUtils';
import VisitCard from './VisitCard';
import VisitDetailsModal from './VisitDetailsModal';
import EmptyState from './EmptyState';
import LoadingState from './LoadingState';
import AddModal from './AddModal';
import AddIcon from '@mui/icons-material/Add';
import Button from '../../../components/Button';
import { getUserDoctorVisit } from '../../../utils/api';
import useStore from '../../../Store/Store';
import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';
const VisitLists = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [selectedVisit, setSelectedVisit] = useState(null);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);

  const user = useStore((state) => state.user);
  const { data: doctorVisits, isLoading } = useQuery({
    queryKey: ['doctorVisits', user?._id],
    queryFn: () => getUserDoctorVisit({ userId: user?._id }),
  });
  const visits = doctorVisits?.data;

  const handleVisitClick = (visit) => {
    setSelectedVisit(visit);
    setShowDetailsModal(true);
  };

  const handleAddVisit = async (formData) => {
    // Mock API call - replace with actual API
  };

  const handleEditVisit = (visit) => {
    // TODO: Implement edit functionality
    console.log('Edit visit:', visit);
    // You can open the AddModal with pre-filled data here
  };

  const handleDeleteVisit = async (visitId) => {
    // Mock API call - replace with actual API
  };

  if (isLoading) {
    return <LoadingState />;
  }

  if (!visits || visits.length === 0) {
    return <EmptyState />;
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant="h6" sx={{ fontSize: '1.5rem', fontWeight: 'bold', color: colors.primary }}>
          {t('visitsHistory')}
        </Typography>
        <Button text={t('addVisit')} startIcon={<AddIcon />} onClick={() => setShowAddModal(true)} />
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {visits.map((visit) => (
          <VisitCard
            key={visit._id}
            visit={visit}
            onVisitClick={handleVisitClick}
            onEdit={handleEditVisit}
            onDelete={handleDeleteVisit}
            formatDate={formatDate}
            formatTime={formatTime}
            getVisitTypeLabel={getVisitTypeLabel}
          />
        ))}
      </Box>

      <VisitDetailsModal
        open={showDetailsModal}
        onClose={() => setShowDetailsModal(false)}
        visit={selectedVisit}
        formatDate={formatDate}
        formatTime={formatTime}
        getVisitTypeLabel={getVisitTypeLabel}
      />

      <AddModal open={showAddModal} onClose={() => setShowAddModal(false)} onSubmit={handleAddVisit} />
    </Box>
  );
};

export default VisitLists;
